import { render, staticRenderFns } from "./GetStartedModal.vue?vue&type=template&id=57619298&"
import script from "./GetStartedModal.vue?vue&type=script&lang=js&"
export * from "./GetStartedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports